import Produce from 'immer';

const initial_state ={
    content: {
        title: 'Welcome Lesson 1'
    }
}

export default function lesson( state = initial_state, action){
    return Produce(state, draft =>{
        switch( action.type ){
            default:
        }
    })
}